package com.appsyde.shared.presentation.style.style

import com.appsyde.shared.presentation.style.token.AppStylesTokens


import org.jetbrains.compose.web.css.*

object AppStylesHeader : StyleSheet() {

    val header by style {
        position(Position.Sticky)
        top(0.px)
        property("z-index", "20")
        padding(3.px,0.px)
        backgroundColor(rgba(255, 255, 255, 0.72))
        property("backdrop-filter", "blur(10px)")
        property("-webkit-backdrop-filter", "blur(10px)")

        property("border-bottom", "1px solid rgba(15,23,42,0.06)")
        property("box-shadow", AppStylesTokens.SHADOW_HEADER)
    }

    val headerInner by style {
        height(46.px)
        maxWidth(1480.px)
        property("margin-left", "auto")
        property("margin-right", "auto")
        paddingLeft(26.px)
        paddingRight(26.px)

        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
    }

    val brandRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(10.px)
    }

    /** Icône météo à la place du dot (🌤️, ☀️, …). */
    val brandWeatherIcon by style {
        property("font-size", "20px")
        property("line-height", "1")
        property("flex-shrink", "0")
    }

    val brandCol by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(2.px)
        property("line-height", "1.2")
    }

    /** Icône AppSyde à gauche du texte dans le header app — petite taille */
    val brandIcon by style {
        height(16.px)
        property("width", "auto")
        property("max-height", "16px")
        property("object-fit", "contain")
        property("flex-shrink", "0")
        property("display", "block")
        property("border-radius", "4px")
    }

    val brand by style {
        fontSize(15.px)
        fontWeight(750)
        property("letter-spacing", "-0.02em")
        color(Color(AppStylesTokens.INK))
    }

    /** Sous-titre sous Appsyde : Journée normale, Journée chargée… */
    val brandSubtitle by style {
        property("font-size", "11px")
        property("font-weight", "450")
        property("color", "rgba(15,23,42,0.5)")
        property("letter-spacing", "0.01em")
    }

    /** Wizard : indicateur d’étape "Setup : 1/2" à la place des onglets. */
    val wizardHeaderInner by style {
        height(36.px)
        maxWidth(1480.px)
        property("margin-left", "auto")
        property("margin-right", "auto")
        paddingLeft(26.px)
        paddingRight(26.px)
        property("display", "grid")
        property("grid-template-columns", "1fr auto 1fr")
        alignItems(AlignItems.Center)
    }

    val wizardStepLabel by style {
        fontSize(13.px)
        fontWeight(600)
        color(Color("rgba(20, 22, 45, 0.7)"))
        property("justify-self", "center")
    }

    val logoutButton by style {
        fontSize(13.px)
        fontWeight(400)
        padding(8.px, 12.px)
        borderRadius(12.px)

        backgroundColor(rgba(255, 255, 255, 0.70))
        property("backdrop-filter", "blur(8px)")
        property("-webkit-backdrop-filter", "blur(8px)")
        property("border", "1px solid rgba(15,23,42,0.08)")
        color(Color("rgba(31,41,55,0.78)"))

        property("cursor", "pointer")
        property("transition", AppStylesTokens.TRANSITION_FAST)

        self + hover style {
            backgroundColor(rgba(255, 255, 255, 0.92))
            color(Color("rgba(31,41,55,0.88)"))
            property("transform", "translateY(-1px)")
            property("box-shadow", "0 10px 24px rgba(15,23,42,0.06)")
            property("border", "1px solid rgba(102,96,230,0.16)")
        }

        self + active style { property("transform", "translateY(0)") }

        self + focus style {
            property("outline", "none")
            property("box-shadow", AppStylesTokens.FOCUS_RING)
        }
    }
}

 object MainTopTabsStyles : StyleSheet() {

    val tabsWrap by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(6.px)

        padding(4.px)
        borderRadius(999.px)

        backgroundColor(Color("rgba(255,255,255,0.55)"))
        border {
            style(LineStyle.Solid)
            width(1.px)
            color(Color("rgba(15, 16, 35, 0.08)"))
        }

        property("backdrop-filter", "blur(10px)")
        property("box-shadow", "0 10px 26px rgba(10,12,22,0.04)")
    }

    val tabButton by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)

        padding(8.px, 12.px)
        borderRadius(999.px)

        border {
            style(LineStyle.Solid)
            width(1.px)
            color(Color("transparent"))
        }

        backgroundColor(Color("transparent"))
        cursor("pointer")

        fontSize(13.px)
        fontWeight(600)
        color(Color("rgba(20, 22, 45, 0.55)"))

        property("appearance", "none")
        property("touch-action", "manipulation")
        property("-webkit-tap-highlight-color", "transparent")
        property("transition", "background 0.15s ease, color 0.15s ease, border-color 0.15s ease")

        self + hover style {
            backgroundColor(Color("rgba(96,96,230,0.06)"))
            color(Color("rgba(50, 55, 160, 0.75)"))
            property("border", "1px solid rgba(96,96,230,0.08)")
        }

        self + focus style {
            property("outline", "none")
            property("box-shadow", AppStylesTokens.FOCUS_RING)
        }
    }

    val tabButtonActive by style {
        backgroundColor(Color(AppStylesTokens.NAV_ACTIVE_SOFT))
        border {
            style(LineStyle.Solid)
            width(1.px)
            color(Color("rgba(96,96,230,0.18)"))
        }
        color(Color(AppStylesTokens.NAV_ACTIVE))

        self + focus style {
            property("outline", "none")
            property("box-shadow", AppStylesTokens.FOCUS_RING)
        }
    }

    // Optional tiny underline inside the active pill (subtle)
    val tabActiveDot by style {
        display(DisplayStyle.InlineBlock)
        width(6.px)
        height(6.px)
        borderRadius(999.px)
        marginLeft(8.px)
        backgroundColor(Color("rgba(96,96,230,0.55)"))
    }
}
